(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-video"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()
    
    this.swiperLoaded = false
    this.initPromise = null
    
    // Load resources asynchronously
    this.loadResources().then(() => {
      this.initializeSlider()
    })
    
    // Setup event delegation for better performance
    this.setupEventDelegation()
  }

  async loadResources() {
    if (window.Swiper) {
      this.swiperLoaded = true
      return Promise.resolve()
    }

    const loadPromises = []

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const scriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
        script.setAttribute('id', 'swiper-script')
        script.onload = () => {
          this.swiperLoaded = true
          resolve()
        }
        script.onerror = reject
        document.head.appendChild(script)
      })
      loadPromises.push(scriptPromise)
    }

    return Promise.all(loadPromises)
  }

  initializeSlider() {
    if (!window.Swiper) {
      console.error('Swiper not loaded')
      return
    }

    const swiperElement = this.querySelector('.swiper')
    if (!swiperElement) return

    const slider = new window.Swiper(swiperElement, this.getSwiperOptions())

    slider.on('slideChange', () => {
      swiperElement.classList.add('swiper-is-changing')
      this.pauseAllVideos()
    })

    slider.on('slideChangeTransitionEnd', () => {
      swiperElement.classList.remove('swiper-is-changing')
    })

    this.setupLazyVideoLoading()
  }

  setupEventDelegation() {
    // Use event delegation instead of multiple listeners
    this.addEventListener('click', (e) => {
      const playBtn = e.target.closest('.ks-shoppable-videos-btn-play')
      const video = e.target.closest('video')
      
      if (playBtn) {
        const videoElem = playBtn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video')
        this.toggleVideoPlay(videoElem)
      } else if (video) {
        this.toggleVideoPlay(video)
      }
    })
  }

  setupLazyVideoLoading() {
    const lazyVideos = this.querySelectorAll('video[data-autoplay="true"]')
    
    if ('IntersectionObserver' in window && lazyVideos.length > 0) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.play().catch(() => {})
            observer.unobserve(entry.target)
          }
        })
      }, { rootMargin: '100px' }) // Reduced from 300px
      
      lazyVideos.forEach((video) => observer.observe(video))
    }
  }

  getSwiperOptions() {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    return {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: this.querySelector('.swiper-pagination'),
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000, disableOnInteraction: false }
        : false,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      lazy: true
    }
  }

  pauseAllVideos() {
    this.querySelectorAll('.ks-shoppable-videos-card').forEach(card => {
      card.setAttribute('data-is-playing', 'false')
      const video = card.querySelector('video')
      if (video && !video.paused) {
        video.pause()
      }
    })
  }

  toggleVideoPlay(video) {
    if (!video) return
    
    const card = video.closest('.ks-shoppable-videos-card')
    const isPlaying = card.dataset.isPlaying === 'true'
    
    // Pause all other videos
    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      if (elem !== card) {
        elem.setAttribute('data-is-playing', 'false')
        const otherVideo = elem.querySelector('video')
        if (otherVideo && !otherVideo.paused) {
          otherVideo.pause()
        }
      }
    })
    
    // Toggle current video
    if (isPlaying) {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play().catch(() => {})
    }
  }
}

customElements.define('ks-shoppable-videos', KsShoppableVideos)

  } catch(e) { console.error(e); }
})();
})();
